export type ModalTone = "default" | "danger" | "warning";
export type ModalSize = "sm" | "md" | "lg";
export type ModalVariant = "dialog" | "drawer";

export function backdropClass(variant: ModalVariant): string {
  return `nb-modal-back${variant === "drawer" ? " is-drawer" : ""}`;
}

export function dialogClass(size: ModalSize, variant: ModalVariant): string {
  return `nb-modal nb-modal-${size}${variant === "drawer" ? " nb-drawer" : ""}`;
}

export function modalIconClass(tone: ModalTone): string {
  return `nb-modal-icon${tone !== "default" ? ` is-${tone}` : ""}`;
}

/** A danger dialog interrupts the person, so it is announced as an alert. */
export function dialogRole(tone: ModalTone): "alertdialog" | "dialog" {
  return tone === "danger" ? "alertdialog" : "dialog";
}
